(() => {
  function init(root) {
    if (root.dataset.clpVideosReady === 'true') return;
    root.dataset.clpVideosReady = 'true';
    const dialog = root.querySelector('[data-clp-video-dialog]');
    const full = dialog?.querySelector('video');
    if (!dialog || !full) return;

    // Previews load and play only while visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          if (!target.src) target.src = target.dataset.src;
          target.play().catch(() => {});
        } else {
          target.pause();
        }
      });
    }, { rootMargin: '100px' });
    root.querySelectorAll('.clp-videos__preview').forEach((video) => observer.observe(video));

    const close = () => dialog.close();
    root.querySelectorAll('[data-clp-video-open]').forEach((card) => {
      card.addEventListener('click', () => {
        full.src = card.dataset.clpVideoOpen;
        full.muted = false;
        dialog.showModal();
        full.play().catch(() => {});
      });
    });
    dialog.querySelector('[data-clp-video-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => {
      full.pause();
      full.removeAttribute('src');
      full.load();
    });
  }

  const initAll = () => document.querySelectorAll('[data-clp-videos]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
